import React from 'react';
import PropTypes from 'prop-types';
import { ButtonContainer, Button } from './style';
import { PaypalIcon } from '../../../atoms/Icon/Paypal';
export var PaypalButton = function PaypalButton(props) {
  return React.createElement(ButtonContainer, null, React.createElement(Button, {
    id: props.id,
    disabled: !props.active,
    active: props.active,
    onClick: function onClick() {
      return props.handleClick();
    }
  }, React.createElement(PaypalIcon, null)));
};
PaypalButton.propTypes = {
  id: PropTypes.string,
  active: PropTypes.bool,
  handleClick: PropTypes.func
};